function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M21.6534 4.8667H10.3467C7.05339 4.8667 4.38672 7.5467 4.38672 10.8267V23.3734C4.38672 26.6534 7.06672 29.3334 10.3467 29.3334H21.6401C24.9334 29.3334 27.6 26.6534 27.6 23.3734V10.8267C27.6134 7.53337 24.9334 4.8667 21.6534 4.8667Z",
  fill: "#ED880F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1333 2.6665H12.8667C11.48 2.6665 10.3467 3.7865 10.3467 5.17317V6.4265C10.3467 7.81317 11.4667 8.93317 12.8533 8.93317H19.1333C20.52 8.93317 21.64 7.81317 21.64 6.4265V5.17317C21.6533 3.7865 20.52 2.6665 19.1333 2.6665Z",
  fill: "#ED880F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3333 13C15.08 13 13.92 13.44 13 14.1733C11.7733 15.1467 11 16.6533 11 18.3333C11 21.28 13.3867 23.6667 16.3333 23.6667C17.68 23.6667 18.9067 23.16 19.8534 22.3333C20.96 21.36 21.6667 19.9333 21.6667 18.3333C21.6667 15.3867 19.28 13 16.3333 13ZM17.6667 18.6667C17.6667 19.0133 17.48 19.3467 17.1867 19.52L15.52 20.52C15.36 20.6134 15.1867 20.6667 15 20.6667C14.6667 20.6667 14.3333 20.4934 14.1466 20.1867C13.8666 19.7067 14.0133 19.0933 14.4933 18.8133L15.68 18.1067V16.6667C15.68 16.12 16.1333 15.6667 16.68 15.6667C17.2267 15.6667 17.68 16.12 17.68 16.6667V18.6667H17.6667Z",
  fill: "#ED880F"
});

function SvgIncompleteMonitors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteMonitors);
export default __webpack_public_path__ + "static/media/incomplete-monitors.4b632819.svg";
export { ForwardRef as ReactComponent };